// extracted by mini-css-extract-plugin
export default {"ns_account_github_login":"AccountGithubLogin_ns_account_github_login__DovNj"};